import axios from 'axios';
import { IS_LOADING, PLAYER_MANAGER_LIST_SUCCESS, PLAYER_MANAGER_LIST_ERROR, PLAYER_MANAGER_UPDATE_SUCCESS, PLAYER_MANAGER_UPDATE_ERROR, PLAYER_MANAGER_FILTER_SUCCESS, PLAYER_MANAGER_FILTER_ERROR, PLAYER_MANAGER_FILTER_LIST_SUCCESS, PLAYER_MANAGER_FILTER_LIST_ERROR } from './Type';
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

export const GetPlayerManagerList = (data, page, size) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/plymetadata/player_list?page=${page}&limit=${size}` , data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: PLAYER_MANAGER_LIST_SUCCESS,
                payload: response
            })
            // dispatch({
            //     type: PLAYER_MANAGER_FILTER_LIST_SUCCESS,
            //     payload: response
            // })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: PLAYER_MANAGER_LIST_ERROR,
                payload: errors
            })
            // dispatch({
            //     type: PLAYER_MANAGER_FILTER_LIST_ERROR,
            //     payload: errors
            // })
        })
}

export const ResetGetPlayerManagerList = () => async (dispatch) => {
    dispatch({
        type: PLAYER_MANAGER_LIST_SUCCESS,
        payload: {}
    })
    dispatch({
        type: PLAYER_MANAGER_FILTER_LIST_SUCCESS,
        payload: {}
    })
}

export const UpdatePlayerManager = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/plymetadata/ply_add`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: PLAYER_MANAGER_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: PLAYER_MANAGER_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetUpdatePlayerManager = () => async (dispatch) => {
    dispatch({
        type: PLAYER_MANAGER_UPDATE_SUCCESS,
        payload: {}
    })
}

export const FilterPlayerManager = (type, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/team/${type}_team`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: PLAYER_MANAGER_FILTER_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: PLAYER_MANAGER_FILTER_ERROR,
                payload: errors
            })
        })
}